module.exports = __webpack_public_path__ + "media/static/flags/es-91332c89b14ac4951c6cfd7bd7c467dc.svg";